import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { AlertState } from '../types';

const initialState: AlertState = {
  type: undefined,
  message: null,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlertAction(state, action) {
      const { type, message } = action.payload;

      state.type = type;
      state.message = message;
    },
    clearAlertAction(state) {
      state.type = undefined;
      state.message = null;
    },
  },
});

export const { setAlertAction, clearAlertAction } = alertSlice.actions;

export const getAlert = (state: RootState): AlertState => state.alert;

export default alertSlice.reducer;
